export default __webpack_public_path__ + "static/media/premium-tea.f33830d2.png";